module.exports = __webpack_public_path__ + "img/banner-1-m.dcf2a6e1.jpg";